import PropTypes from 'prop-types';
import "pages/Profile/UserControls.scss";
import { ReactComponent as IconWarning } from "assets/images/icons/warning-alt.svg";
import ButtonBlock from "pages/Profile/ButtonBlock";

function UserControls({ userId }) {
  return (
    <>
      <div className="user-controls">
        <ButtonBlock userId={ userId }/>

        <a href={ 'mailto:trefpunt@anbo.nl?subject=Melding over gebruiker' } className={ 'button button--ghost' }>
          <IconWarning/>
          Maak een melding
        </a>
      </div>
    </>
  )
}

UserControls.propTypes = {
  userId: PropTypes.number.isRequired,
}

export default UserControls;
